import styled from 'styled-components'

export const SkeletonRows = styled.div`
    width: 100%;
`;

export const SkeletonRow = styled.div`
    min-height: 116px;
    padding: 24px 4px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    display: grid;
    grid-template-columns: 10px minmax(0, 1fr) 58px;
    align-items: center;
    gap: 18px;

    &:last-child {
        border-bottom: 0;
    }
`;

export const SkeletonContent = styled.div`
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 9px;
`;
